import { useState, useMemo } from "react";

import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";

import { getLabel } from "../../tools/Dictionary";

const ConditionDesignerUserVariable = (props) =>
{

  //Props
  //const IsDesktop = props.IsDesktop;
  const OnCloseModal = props.OnCloseModal;
  const UserVariable = props.UserVariable;
  const OnClickVariable = props.OnClickVariable;

  const [loading] = useState(false);
  const [alert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });

  //Variable
  const listVariable = useMemo(() => {

    let currentStep = undefined;

    let list = [];

    UserVariable.forEach((u, index) => {
      
      if (u.step != currentStep){

        list.push({
          step: u.step,
          stepTitle: u.stepTitle,

          component: []
        });

        currentStep = u.step;
        
      }

      list[list.length - 1].component.push({
        component: u.component,
        componentName: u.componentName,
        index
      });


    });

    return list;

  }, [UserVariable])


  return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "600px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
          {getLabel("ConditionDesigner", "userVariable")}
        </div>
        <div className="page_modal_body_cont">
          {listVariable.map((v, indexV) => (
            <div className="conditiondesigner_user_step" key={indexV}>
              <div className="conditiondesigner_user_step_label">
                {v.stepTitle}
              </div>
              {v.component.map((c, indexC) => (
                <div className="conditiondesigner_user_component" onClick={() => OnClickVariable(c.index)} key={indexC}>
                  {c.componentName}
                </div>
              ))}
            </div>
          ))}
        </div>
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(loading && !OnCloseModal) ? undefined : OnCloseModal}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  );

};

export default ConditionDesignerUserVariable